import FeatureReferenceQueryPatternType from './../FeatureReferenceQueryPatternType.js';
/**
 * @memberof feature-references
 */
class InheritParameters {
    loadForm() {
        return Promise.resolve(null);
    }
    evaluate() {
        return Promise.resolve(null);
    }
}
InheritParameters.PATTERN_TYPE = FeatureReferenceQueryPatternType.INHERIT;
export default InheritParameters;
